export class SearchPageComponent {
    private _currentContext: JQuery = $();

    private _selectContext: JQuery = $();

    private _moduleOptions = {
        managedElement: "",
        paramsObject: {
            searchText: "",
            pageNumber: 1,
            sortOption: "0"
        }
    };

    private _classMap = {
        js: {
            select: ".js-pcg-sort-select"
        }
    };

    private parseContext(): void {
        this._selectContext = $(this._classMap.js.select, this._currentContext);
    }

    private bindEvents(): void {
        this._selectContext.on("change", (e) => {
            this._moduleOptions.paramsObject.sortOption = $(e.currentTarget).val() as string;
            const paramsString = $.param(this._moduleOptions.paramsObject);
            window.open(`?${paramsString}`, "_self");
        });
    }

    public init(context: JQuery, options: object): void {
        this._currentContext = context || this._currentContext;

        $.extend(this._moduleOptions, options);

        this.parseContext();
        this.bindEvents();
    }
}
